<div class="list row" *ngIf="hasGuidelineSegmentSmartObjectData()">
  <div [swIndentSpacer]="indentLevel"></div>
  <sw-attribute-list
    (attributesChange)="saveAttributes($event)"
    [attributes]="guideline.smartObjectData | getDataAttributes"
  >
  </sw-attribute-list>
</div>
